module.exports = __webpack_public_path__ + "static/media/excel.c3089518.svg";